export default "__VITE_ASSET__CPP$E7Ry__"